/**
* Logo Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'logo-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let sliderCounter = 0;
      let sliderElements = '';

      if ( $( '.logo-slider' ).length ) {
        sliderCounter++;
        if ( sliderElements === '' ) {
          sliderElements += '.logo-slider';
        } else {
          sliderElements += ', .logo-slider';
        }
      }

      $( '.logo-slider__slider' ).slick( {
        dots: true,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-slider', COMPONENT );
} )( app );
